import frenchkiss from 'frenchkiss'
import en from '../locales/en/index'
import fr from '../locales/fr'

frenchkiss.locale('en') // 'fr'
frenchkiss.fallback('en')
frenchkiss.set('en', en)
frenchkiss.set('fr', fr)

const i18n = frenchkiss
export default i18n
// for e2e; default will alias incorrectly
export const lang = i18n
